<div *ngIf="!environment.production" class="environment-{{ environment.name }}">
  This is the <strong>{{ environment.name }}</strong> environment.
</div>
